<div class="vendor-edit">
  <div class="vendor-edit__content">
    <div class="vendor-edit__layout">
      <div class="vendor-edit__header">
        <div class="vendor-edit__heading">
          <h1 class="page-title">Edit Vendor</h1>
          <p class="page-subtitle">Update vendor profile and vendor type for inventory operations.</p>
        </div>
        <div class="vendor-edit__actions">
          <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
          <app-button type="button" [disabled]="!canSave" (click)="save()">
            {{ isSaving ? "Saving..." : "Save changes" }}
          </app-button>
        </div>
      </div>

      <app-card>
        <form [formGroup]="form" class="vendor-edit__form">
          <div class="vendor-edit__form-grid">
            <div class="vendor-edit__form-field">
              <label for="name" class="vendor-edit__form-label">Vendor Name</label>
              <input
                id="name"
                type="text"
                formControlName="name"
                class="vendor-edit__form-input"
                [class.vendor-edit__form-input--error]="form.get('name')?.invalid && form.get('name')?.touched" />
              @if (form.get('name')?.invalid && form.get('name')?.touched) {
              <div class="vendor-edit__form-error">Vendor name is required.</div>
              }
            </div>

            <div class="vendor-edit__form-field">
              <label for="vendor-pages-edit-vendoreditpage-field-1" class="vendor-edit__form-label">Type</label>
              <app-autocomplete
                [prefetchOnInit]="true"
                [options]="typeOptions"
                [selectedValue]="form.getRawValue().type || ''"
                placeholder="Search type..."
                [minLength]="1"
                [debounceMs]="200"
                (selectionChange)="onTypeChange($event)"></app-autocomplete>
              @if (form.get('type')?.invalid && form.get('type')?.touched) {
              <div class="vendor-edit__form-error">Vendor type is required.</div>
              }
            </div>
          </div>

          <div class="vendor-edit__form-grid">
            <div class="vendor-edit__form-field">
              <label for="contactPerson" class="vendor-edit__form-label">Contact Person</label>
              <input id="contactPerson" type="text" formControlName="contactPerson" class="vendor-edit__form-input" />
            </div>

            <div class="vendor-edit__form-field">
              <label for="phone" class="vendor-edit__form-label">Phone</label>
              <input id="phone" type="text" formControlName="phone" class="vendor-edit__form-input" />
            </div>
          </div>

          <div class="vendor-edit__form-grid">
            <div class="vendor-edit__form-field">
              <label for="email" class="vendor-edit__form-label">Email</label>
              <input id="email" type="email" formControlName="email" class="vendor-edit__form-input" />
            </div>
          </div>

          <div class="vendor-edit__form-field">
            <label for="vendor-pages-edit-vendoreditpage-field-2" class="vendor-edit__form-label">Note</label>
            <app-rich-text-editor formControlName="note" placeholder="Write vendor notes..."></app-rich-text-editor>
          </div>
        </form>
      </app-card>

      <app-card class="vendor-edit__address-card">
        <div class="vendor-edit__section-header">
          <div>
            <h2 class="vendor-edit__section-title">Address Information</h2>
            <p class="vendor-edit__section-hint">Select administrative area and line details for this vendor.</p>
          </div>
        </div>

        <app-location-selector [value]="addressValue" (addressChange)="onAddressChange($event)"></app-location-selector>
      </app-card>
    </div>
  </div>
</div>
